"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputZip = void 0;
const react_1 = __importStar(require("react"));
const is_browser_1 = __importDefault(require("is-browser"));
const icons_core_1 = require("@volkswagen-onehub/icons-core");
const client_1 = require("@apollo/client");
const custom_text_input_1 = require("../custom-text-input");
const disable_focus_container_1 = require("../disable-focus-container");
const text_helpers_1 = require("../helpers/text-helpers");
const use_is_mobile_1 = require("../use-is-mobile");
const helpers_1 = require("../helpers");
const styles_1 = require("./styles");
const scroll_to_top_1 = require("../utils/scroll-to-top");
const errorCodes = {
    invalidZip: 'INV01',
    communicationError: 'INV02'
};
/* eslint-disable-next-line react/display-name */
exports.InputZip = (0, react_1.forwardRef)((props, ref) => {
    const { placeholder, autoFocus, label, name, iconSize, fontSize, hideBorderBottom, maxLength, errorText, isDefault, inputStyles, iconStyles, hideLocationText, hideOnMobile, errorMessageClasses, zipManager, validateZipQuery, showDeleteButton, scrollToTopOnUpdate, updateOnBlur, useZipData, successCallback, trackingErrorCallback, onHandleZipCodeStatus } = props;
    const { zipData, updateAppZipData, zipSuggested, isLoading, updateIsLoading } = useZipData();
    const [zipInputVal, setZipInputVal] = (0, react_1.useState)(zipManager.getZip() !== '' ? zipManager.getZip() : '');
    //Temp value just to hold the last zip validated in case the user validate again do not allow it
    const [zipValidated, setZipValidated] = (0, react_1.useState)({
        zip: zipManager.getZip() !== '' ? zipManager.getZip() : '',
        valid: zipManager.getZip() !== ''
    });
    const [showErrorMsg, setShowErrorMsg] = (0, react_1.useState)(false);
    const [zipErrorMsg, setZipErrorMsg] = (0, react_1.useState)(errorText ? errorText : '');
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    const isMobile = (0, use_is_mobile_1.useIsMobile)(helpers_1.Breakpoints.b560);
    const [screenOrientation, setScreenOrientation] = (0, react_1.useState)(is_browser_1.default && window.matchMedia('(orientation: portrait)').matches
        ? 'portrait'
        : 'landscape');
    const hasAddress = zipData.city !== '' && zipData.state !== '';
    const client = (0, client_1.useApolloClient)();
    /**
     * Manage process to validate the zip code
     */
    const updateZip = (data) => {
        let zipDataParam = {
            zip: zipInputVal,
            zipError: false,
            zipSubmited: true,
            activeZipModal: false,
            state: data.state,
            city: data.city,
            lat: data.lat,
            lng: data.lng
        };
        updateIsLoading(true);
        successCallback && successCallback(zipDataParam);
        updateAppZipData(zipDataParam);
        onHandleZipCodeStatus && onHandleZipCodeStatus(false);
        scrollToTopOnUpdate && (0, scroll_to_top_1.scrollToDocumentTop)();
    };
    /**
     *  Manage validation to verify if the zip is valid
     * @param validZip If is a valid zip code
     */
    const validateZipChange = (validZip) => {
        if (validZip) {
            setShowErrorMsg(false);
            if (zipValidated.zip !== zipInputVal || !zipData.zipSubmited) {
                axiosZipValidation();
                updateIsLoading(false);
            }
            else {
                //Do not make the validation because  either already validate the zip or is the same as the one on the zip data so no validation is necesary
                if (!zipValidated.valid) {
                    setShowErrorMsg(true);
                    onHandleZipCodeStatus && onHandleZipCodeStatus(true);
                    trackingErrorCallback && trackingErrorCallback(errorCodes.invalidZip);
                }
                else {
                    onHandleZipCodeStatus && onHandleZipCodeStatus(false);
                }
            }
        }
        else {
            setShowErrorMsg(true);
            onHandleZipCodeStatus && onHandleZipCodeStatus(true);
            trackingErrorCallback && trackingErrorCallback(errorCodes.invalidZip);
        }
    };
    /**
     * Validate the zip using an API
     */
    const axiosZipValidation = async () => {
        try {
            const { data, error } = await client.query({
                query: validateZipQuery,
                variables: { zipcode: zipInputVal }
            });
            if (!error) {
                if (data && data.validateZip.valid) {
                    setShowErrorMsg(false);
                    updateZip(data.validateZip);
                    onHandleZipCodeStatus && onHandleZipCodeStatus(false);
                    setTimeout(() => {
                        updateIsLoading(false);
                    }, 500);
                }
                else {
                    setShowErrorMsg(true);
                    onHandleZipCodeStatus && onHandleZipCodeStatus(true);
                    trackingErrorCallback && trackingErrorCallback(errorCodes.invalidZip);
                }
                setZipValidated({
                    zip: zipInputVal,
                    valid: data && data.validateZip ? data.validateZip.valid : false
                });
            }
            else {
                onHandleZipCodeStatus && onHandleZipCodeStatus(true);
                console.error('ERROR: Zip validation, status: ', error);
            }
        }
        catch (e) {
            console.error('There was an error calling the zip validation method', e);
            setZipErrorMsg('There was an error. Please try again');
            setShowErrorMsg(true);
            onHandleZipCodeStatus && onHandleZipCodeStatus(true);
            trackingErrorCallback &&
                trackingErrorCallback(errorCodes.communicationError);
        }
    };
    /**
     * This implementation allows some parent component call function through references
     */
    (0, react_1.useImperativeHandle)(ref, () => ({
        applyZip() {
            applyZipBtnAction();
        }
    }));
    const applyZipBtnAction = () => {
        const validZipRegex = /^[0-9]{5}$/;
        validateZipChange(validZipRegex.test(zipInputVal));
    };
    /**
     * Listening to the onKeyPress event this function updates the store using the zip's information
     * @param event onKeyPress event
     */
    const changeZipPressedEnterKey = (event) => {
        const key = event.which || event.keyCode;
        if (key === 13) {
            const validZipRegex = /^[0-9]{5}$/;
            validateZipChange(validZipRegex.test(zipInputVal));
            updateIsLoading(false);
        }
    };
    /**
     * Listening to the onChange event this function updates input state
     * @param event onChange event
     */
    const onChange = (event) => {
        const onChangeZipRegex = /^[0-9]{0,5}$/;
        const zipValue = event.currentTarget.value;
        if (zipValue === zipInputVal) {
            onHandleZipCodeStatus && onHandleZipCodeStatus(false);
        }
        else {
            onHandleZipCodeStatus && onHandleZipCodeStatus(true);
        }
        if (onChangeZipRegex.test(zipValue)) {
            setShowErrorMsg(false);
            setZipInputVal(zipValue);
        }
    };
    const onScrolling = () => {
        let heightToHideFrom = 0;
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        if (winScroll > heightToHideFrom) {
            if (isMobile && hideOnMobile) {
                isVisible && setIsVisible(false);
            }
            else {
                setIsVisible(true);
            }
        }
        else {
            setIsVisible(true);
        }
    };
    /**
     * Handles clear all button
     */
    const onHandleClearInputButton = () => {
        setZipInputVal('');
        onHandleZipCodeStatus && onHandleZipCodeStatus(true);
        setShowErrorMsg(false);
    };
    /**
     * Validates zipcode when on focus out allowing no user interaction
     */
    const onHandleOnBlur = () => {
        if (!updateOnBlur)
            return;
        const validZipRegex = /^[0-9]{5}$/;
        validateZipChange(validZipRegex.test(zipInputVal));
        updateIsLoading(false);
    };
    const onScreenOrientationChange = () => {
        if (is_browser_1.default && window.matchMedia('(orientation: portrait)').matches) {
            setScreenOrientation('portrait');
        }
        if (is_browser_1.default && window.matchMedia('(orientation: landscape)').matches) {
            setScreenOrientation('landscape');
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', onScreenOrientationChange);
        return () => window.removeEventListener('resize', onScreenOrientationChange);
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('scroll', onScrolling);
        return () => window.removeEventListener('scroll', onScrolling);
    }, []);
    (0, react_1.useEffect)(() => {
        if (zipData.zip == '') {
            setZipInputVal(zipSuggested);
        }
    }, [zipSuggested]);
    (0, react_1.useEffect)(() => {
        //If an update is made from other input zip, update the value
        if (zipData.zip != '') {
            setZipInputVal(zipData.zip);
        }
    }, [zipData]);
    return (react_1.default.createElement(styles_1.InputZipWrapper, { className: `input-zip__wrapper ${isVisible ? 'show' : 'hide'} is-${screenOrientation}`, isDefault: isDefault, inputStyles: inputStyles, iconStyles: iconStyles },
        react_1.default.createElement(disable_focus_container_1.DisableFocusContainer, { className: `focus__container ${errorMessageClasses} ${zipErrorMsg && showErrorMsg ? 'has-error' : ''}` },
            react_1.default.createElement(custom_text_input_1.CustomTextInput, { appearance: zipErrorMsg && showErrorMsg
                    ? text_helpers_1.TextInputAppearance.Error
                    : text_helpers_1.TextInputAppearance.Default, onChange: onChange, onKeyPress: changeZipPressedEnterKey, value: zipInputVal ? zipInputVal : '', rightIcon: iconSize === 'small' ? (react_1.default.createElement(icons_core_1.Magnifier, { variant: "small", ariaLabel: "Search" })) : (react_1.default.createElement(icons_core_1.Magnifier, { variant: "default", ariaLabel: "Search" })), rightIconColor: "#001e50", rightIconBtnFun: applyZipBtnAction, placeholder: placeholder, autoFocus: autoFocus, label: label, useCustomZipText: true, fontSize: fontSize, hideBorderBottom: hideBorderBottom, name: name, maxLength: maxLength, errorText: zipErrorMsg && showErrorMsg ? zipErrorMsg : '', customTextColor: "#001e50", type: "tel", ariaLabel: "Search", onBlur: onHandleOnBlur }),
            showDeleteButton && (react_1.default.createElement(styles_1.StyledClearInputButton, { onClick: onHandleClearInputButton },
                react_1.default.createElement(icons_core_1.Close, { variant: "small" })))),
        !hideLocationText && (react_1.default.createElement(styles_1.LocationTextWrapper, { className: "location-text__wrapper" },
            react_1.default.createElement(styles_1.LocationText, { className: "location-text" }, !isLoading &&
                !(zipErrorMsg && showErrorMsg) &&
                hasAddress &&
                `${zipData.city}, ${zipData.state}`)))));
});
exports.default = exports.InputZip;
